const instructions = [
    {
        paragraphs: [
            "Les mots diffèrent selon leur niveau d’abstraction. Certains mots font référence à des objets palpables, des matériaux ou des personnes qui peuvent être facilement perçus par nos sens. Nous pouvons considérer de tels mots comme des mots concrets. D’autres mots font référence à des concepts abstraits qui ne sont pas facilement objectivés ou perceptibles. Vous devez évaluer pour chacun des mots de la liste qui suit leur degré d’abstraction."
        ]
    },
    {
        paragraphs: [
            "Vous fournirez vos réponses sur une échelle en 5 points, où \"1\" correspond à un concept abstrait et \"5\" à un concept concret. Vous devez réaliser votre évaluation en choisissant le nombre entre 1 et 5 qui correspond le plus à votre jugement. N’hésitez pas à utiliser toute la gamme des nombres compris entre 1 et 5, et dans le même temps ne vous préoccupez pas de combien de fois vous avez utilisé un numéro en particulier tant qu’il fait référence à votre véritable jugement. Répondez le plus spontanément possible, mais ne soyez pas négligent dans vos notations."
        ]
    },
    {
        paragraphs: [
            "Par exemple, vous pouvez estimer que le mot \"chaise\" correspond assez fortement à un concept concret et vous entourez la réponse \"4\" ou \"5\". Au contraire vous jugez le mot \"charité\" comme correspondant à un concept relativement abstrait et choisissez la réponse \"2\" ou \"1\"."
        ],
        warnings: [
            "Vos réponses NE sont PAS enregistrées. Si vous fermez cet onglet ou votre navigateur, vous perdrez vos réponses et vous devrez recommencer du début."
        ]
    }
];
export default instructions;
